import { useEffect, useState } from "react";

import { productsLogoHeight } from "@sso/constant";
import { Product } from "@sso/types";

import { ProductCardAction } from "./ProductCardAction";
import { ProductCardContainer } from "./ProductCardContainer";
import { ProductCardDescription } from "./ProductCardDescription";
import { ProductCoverImg, ProductLogoContainer, ProductLogoImg } from "./ProductCardImage";

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({
  product: { name, businessDescription, logoImage, mainImage, url, softwareId },
}: ProductCardProps) => {
  const logoHeight = productsLogoHeight[name];

  const [imageSources, setImageSources] = useState({
    logo: undefined,
    main: undefined,
  });

  useEffect(() => {
    const mainImagePromise = import(`@sso/assets/software-images/main/${softwareId.toLocaleUpperCase()}.png`)
      .then(mainImage => mainImage.default)
      .catch(_ => {
        return null;
      });

    const logoImagePromise = import(`@sso/assets/software-images/logo/${softwareId.toLocaleUpperCase()}.png`)
      .then(image => image.default)
      .catch(_ => {
        return null;
      });

    Promise.all([mainImagePromise, logoImagePromise])
      .then(([mainImage, logoImage]) => {
        setImageSources({ main: mainImage, logo: logoImage });
      })
      .catch(_ => {
        return null;
      });
  }, [softwareId]);

  return (
    <ProductCardContainer>
      <ProductCoverImg src={imageSources.main ?? ""}>
        <ProductLogoContainer>
          <ProductLogoImg src={imageSources.logo} alt={name} height={logoHeight} />
        </ProductLogoContainer>
      </ProductCoverImg>
      <ProductCardDescription description={businessDescription} />
      <ProductCardAction url={url} />
    </ProductCardContainer>
  );
};
